import { useEffect, useState } from 'react';
import { usePagination } from 'shared-ui';

import { QueryKeyEnum } from 'core/global.enum';
import { QueryKeyLocalStorageEnum } from 'context/query/queryContext/QueryContext.enum';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { useQuery } from 'hooks/useQuery/useQuery';
import { fetchServers } from 'api/servers/servers';

import { SequencesList } from './SequencesList';
import { SequencesListContainerProps } from './SequencesList.types';

export const SequencesListContainer = ({ sequencesTableSearchQuery }: SequencesListContainerProps) => {
  const {
    storedQueries: { [QueryKeyLocalStorageEnum.SEQUENCES]: sequencesQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const [sequencesCount, setSequencesCount] = useState(0);
  const { page, rowsPerPage, setPage, setRowsPerPage } = usePagination();

  const { data: serversResponse, isLoading } = useQuery([QueryKeyEnum.SERVERS], fetchServers);

  useEffect(() => {
    setQuery(QueryKeyLocalStorageEnum.SEQUENCES, {
      ...sequencesQuery,
      limit: rowsPerPage,
      offset: rowsPerPage * page,
    });
  }, [page, rowsPerPage]);

  return (
    <SequencesList
      servers={serversResponse?.data}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      sequencesCount={sequencesCount}
      setSequencesCount={setSequencesCount}
      sequencesTableSearchQuery={sequencesTableSearchQuery}
    />
  );
};
